/* global femcare */

femcare.askExpert.askQuestion = {
    init: function() {
        if ($('.ask-expert__form-toggle').length) {
            this.askExpertForm();
        }
    },

    /**
     * Init ask expert form slide down.
     **/
    askExpertForm: function() {
        var formOpen = false;

        $('.ask-expert__form-toggle').on('click', function() {
            var $form = $(this)
                .parents('.ask-expert')
                .find('.ask-expert-form');

            $form.slideToggle();

            if (!formOpen) {
                var scrollTop = $form.offset().top;
                $('html, body').animate(
                    {
                        scrollTop: scrollTop
                    },
                    1000
                );

                formOpen = true;

                return;
            }

            formOpen = false;
        });
    }
};
